import * as userRequest from "@/utils/userRequest";

export default async function getRankDataService(
  token: string,
  onSuccess?: (data?: any) => any,
  handleError?: (err?: any) => any
) {
  try {
    const res = await userRequest.get("affiliates/get-rank-progress", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("🚀 ~ getRankDataService ~ res:", res);
    if (res) {
      onSuccess && onSuccess(res);
      return res;
    }
  } catch (err) {
    console.error("🚀 ~ getRankDataService ~ err:", err);
    handleError && handleError(err);
    throw err;
  }
}
